import httpClient from "../../utilities/http-client";
import { MarketInfo } from "../../models/circuito/MarketsGeo";
import { AssociationsGroupedByNationsResponse } from "../../models/responses/AssociationsGroupedByNationsResponse";


export const associationsList = async () => {
	try {
		debugger;
		const { data } = await httpClient.get<AssociationsGroupedByNationsResponse[]>("/associations");
		return data;
	} catch (e: any) {
		throw  e;
	}
};

export const associationsListSearch = async (search:string) => {
	try {
		const { data } = await httpClient.get<AssociationsGroupedByNationsResponse[]>(`/associations/search?query=${search}`);
		return data;
	} catch (e: any) {
		throw  e;
	}
};


export const geoCircuitSearch = async (latitudemin:number, longitudemin:number, latitudemax:number, longitudemax:number) => {
	try {
		const { data } = await httpClient.get<MarketInfo[]>(`/activities/geo/${latitudemin}/${longitudemin}/${latitudemax}/${longitudemax}`);
		return data;
	} catch (e: any) {
		throw  e;
	}
};
